import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'rr0034',
    ecrans: ['00-2']
});
